<template>
  <div>
    <ks-flex :width="null" v-if="screenSizeId < 4 && showFacility">
      <ks-button
          v-show="!showFacilitySelector"
          color="link"
          classIcon="far fa-building"
          @onClick="showFacilitySelector = true;"
          class="p-1 m-1"
          id="facility-button"
      />
      <ks-text
          :text="selectedFacility?.campaign_short_name"
          v-if="selectedFacility"
          v-show="!showFacilitySelector"
      />
    </ks-flex>
    <ks-select-field
        v-show="(screenSizeId >= 4 || showFacilitySelector) && showFacility"
        type="select"
        options="facility_data_provider.list.list"
        optionLabel="campaign_facility"
        optionValue="id"
        @onChange="setFacility"
        :formGroup="false"
        id="facility-dropdown"
        :showNullOption="true"
        :nullOptionLabel="screenSizeId >= 4 ? 'Please select a facility...' : 'Facility...'"
        :disableNullOption="true"
        :hideNullOption="true"
        class="mr-1"
        :defaultValue="init_selectedFacility.id"
    />
  </div>
</template>

<script>
import checkPermissions from '../../mixins/checkPermissions';

export default {
  name:     "ks-facility-selector",
  mixins:   [checkPermissions],
  props:    {
    dataProvider:      {type: String},
    dataProviderArray: {type: Array},
    showFacility:      {type: Boolean, default: true},
    defaultFacilityId: {type: Number, default: null}
  },
  methods:  {
    setFacility(val) {
      if (val?.input) {
        let list              = app.getDataprovider('facility_data_provider').list;
        let facility          = list.find((l) => l.id === val.input);
        this.selectedFacility = facility ? facility : {'id': null};
        this.loadLists(this.selectedFacility.id)
        this.$emit('onSelectedFacilityChange', facility);
        this.showFacilitySelector = false;
      }
    },
    setFacilityIfSingle(time = 0) {
      setTimeout(() => {
        let facility_data_provider = app.getDataprovider('facility_data_provider');
        if (facility_data_provider.list.length === 1) {
          this.selectedFacility = facility_data_provider.list[0];
        } else if (app.activeMultiCampaigns.length === 1) {
          _this.selectedFacility = facility_data_provider.list.find(facility => facility.id === app.activeMultiCampaigns[0].default_facility_id);
        }
      }, time)
    },
    loadLists(facilityId) {
      let data_provider = null;
      if (this.dataProviderArray) {
        this.dataProviderArray.forEach(dp => {
          data_provider = app.getDataprovider(dp);
          if (facilityId === this.init_selectedFacilityId && dp === this.dataProvider) {
            this.init_selectedFacilityId = null;
          } else {
            data_provider.updateFilters({'facility_id': facilityId, 'facility_id_csv': facilityId?.toString()}, true);
          }
        })
      } else {
        data_provider = app.getDataprovider(this.dataProvider);
        if (facilityId === this.init_selectedFacilityId) {
          this.init_selectedFacilityId = null;
        } else {
          data_provider.updateFilters({'facility_id': facilityId, 'facility_id_csv': facilityId.toString()}, true);
        }
      }
    }
  },
  computed: {
    facilityList() {
      this.l_facilityList = app.getDataprovider('facility_data_provider')?.list;
      return this.l_facilityList;
    },
    selected_campaigns() {
      return global.app.store.state.rms_ui.auth.selected_campaigns;
    },
    screenSizeId() {
      return app.layout.screenSizeId;
    },
    selectedFacility: {
      get: () => {
        return app.store.state.ks_app.global_data.selectedFacility;
      },
      set: (value) => {
        app.store.commit('ks_app/global_data/setSelectedFacility', value);
      }
    },
  },
  watch:    {
    selectedFacility(val, oldVal) {
      this.init_selectedFacility = {'id': val.id}
    },
    facilityList(val, oldVal) {
      if (this.consoleLogs) console.log("facilityList watcher", val, oldVal);
      this.setFacilityIfSingle(2000);
    },
  },
  data() {
    return {
      l_facilityList:        [],
      showFacilitySelector:  false,
      init_selectedFacility: {'id': null},
      init_selectedFacilityId: null
    }
  },
  mounted() {
    let _this = this;
    setTimeout(function () {
      let queryStringObject = app.decodeQueryStringParams(_this.$route.query.s);
      if (queryStringObject?.filters?.facility_id_csv) {
        let facility_data_provider = app.getDataprovider('facility_data_provider');
        let foundFac               = facility_data_provider.list.findIndex(facility => facility.id === parseInt(queryStringObject.filters.facility_id_csv));
        if (foundFac > -1) {
          _this.init_selectedFacility.id = parseInt(queryStringObject.filters.facility_id_csv);
          _this.init_selectedFacilityId = parseInt(queryStringObject.filters.facility_id_csv);
        }
      } else if (queryStringObject?.filters?.facility_id) {
        let facility_data_provider = app.getDataprovider('facility_data_provider');
        let foundFac               = facility_data_provider.list.findIndex(facility => facility.id === queryStringObject.filters.facility_id);
        if (foundFac > -1) {
          _this.init_selectedFacility.id = parseInt(queryStringObject.filters.facility_id);
          _this.init_selectedFacilityId = parseInt(queryStringObject.filters.facility_id);
        }
      }
    }, 2000)
    this.setFacilityIfSingle(2000);
    window.addEventListener('click', function (e) {
      if (document.getElementById('facility-dropdown')?.contains(e.target) ||
          document.getElementById('facility-button')?.contains(e.target)
      ) {
      } else {
        _this.showFacilitySelector = false;
      }
    });
  }
}
</script>
